import { FiltersParams } from '@helpers/http.helper';
import { TaskFilters } from '@interfaces/task-filters';

export class TaskFiltersHelper {
  static toParams(filters: TaskFilters): FiltersParams {
    return {
      prestation: typeof filters?.prestation === 'boolean' ? filters.prestation : undefined,
      time_tracking: typeof filters?.timeTracking === 'boolean' ? filters.timeTracking : undefined,
      additional_mission: typeof filters?.additionalMission === 'boolean' ? filters.additionalMission : undefined
    };
  }
}
